module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07416_logo_200x200.bfd794e5.png";